import { WarningOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import styles from './FetchErrorSection.module.scss';

export const FetchErrorSection = () => (
  <div className={styles.wrapper}>
    <WarningOutlined className={styles.icon} />
    <p className={styles.annotation}>Произошла ошибка при загрузке данных</p>
    <Button
      type="primary"
      onClick={() => window.location.reload()}
    >
      Обновить страницу
    </Button>
  </div>
);
